import { ChangeDetectorRef, Component, Inject, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { TuiDialogContext } from "@taiga-ui/core";
import { Feedback } from "src/app/core/models/feedback";
import { EventDataService } from "src/app/core/services/event-data.service";
import { ApiService } from "src/app/core/services/shared/api.service";

import { ScholarshipService } from "src/app/core/services/scholarship/scholarship.service";
import { FieldInfo, Question } from "virtue-form/lib/modals/modal";

import { POLYMORPHEUS_CONTEXT } from "@tinkoff/ng-polymorpheus";
import { GlobalVarService } from "src/app/core/services/shared/global-var.service";
import { NotificationService } from "src/app/core/services/shared/notification.service";
import { Answer, CodehelpService } from "virtue-form";
import { CheckLoginSessionService } from "src/app/core/services/shared/check-login-session.service";
@Component({
  selector: "app-feedbackform",
  templateUrl: "./feedbackform.component.html",
  styleUrls: ["./feedbackform.component.scss"],
})
export class FeedbackformComponent implements OnInit {
  feedbackData: any = {};
  feedbacks: any;
  alert: any;
  feedBackForm: FormGroup;
  basepath: string = "";
  feedBackFormSubmit: boolean = false;
  answerMap: Map<Number, Answer> = new Map();
  feedBackFormData: Array<Question>;
  validated: FieldInfo | undefined;
  isValid: boolean = false;
  errorMessage: Array<string> = [];
  showError = true;
  disableMap: Map<Number, boolean> = new Map();

  constructor(
    private scholarshipService: ScholarshipService,
    @Inject(POLYMORPHEUS_CONTEXT)
    private readonly context: TuiDialogContext<any, any>,
    private formBuilder: FormBuilder,
    private router: Router,
    private checkUserLogin :CheckLoginSessionService,

    private eventDataService: EventDataService,
    public globalvar: GlobalVarService,
    // public mseDataService: MseDataService,
    private apiService: ApiService,
    private cdRef: ChangeDetectorRef,
    private codehelp: CodehelpService,
    private notificatioService: NotificationService,
    private route: ActivatedRoute
  ) {
   
    this.globalvar.feedBackFormAnswerMap.clear();
    if(this.globalvar.feedBackFormAnswerMap)
    {

      this.answerMap = this.globalvar.feedBackFormAnswerMap;
    }
   
  }

  get f() {
    return this.feedBackForm.controls;
  }
  ngOnInit() {
    //  const data=sessionStorage.getItem("DATA")
    //  if(data==null)
    //  this.router.navigate(['/profile'])
   
    if (this.globalvar.feedBackFormData) {
      this.feedBackFormData = this.globalvar.feedBackFormData?.filledByInfos;
    }

    this.basepath = this.globalvar.basepath;
    this.scholarshipService.getFeedbacks().subscribe((res) => {
      this.feedbacks = res.data;
    });

    this.feedBackForm = this.formBuilder.group({
      comment: ["", Validators.required],
      email: ["", [Validators.required, Validators.email]],
      type: ["", Validators.required],
    });
  }

  close() {
    this.context.completeWith("");
  }

  onSubmitForm() {
    if(this.checkUserLogin.clickActionToCheckLogout()==true)
    {
    this.apiService.submitFeedbackForm(
      this.answerMap,
      0,
      false,
      this.globalvar?.serviceConfig?.serviceType,
      (resp) => {
        if (resp) {
          this.notificatioService.showNotification(
            "Thank you for valuable feedback. We will get back to you soon.",
            "Feedback",
            true,
            "success"
          );
        }
      }
    );
    }
  }
  onNext(e) {
    this.feedBackFormSubmit = true;

    let postData: Feedback = { ...this.feedBackForm.value };
    let isRequired = true;
    if (
      postData.comment != undefined &&
      postData.comment.length !== 0 &&
      postData.email &&
      postData.email.length !== 0 &&
      postData.type &&
      postData.type.length !== 0
    ) {
      isRequired = false;
    }

    if (this.feedBackForm.invalid || isRequired) {
      this.alert = {
        msg_type: "danger",
        text: "Sorry we are unable to process your request. Please try again.",
      };
      setTimeout(() => {
        this.alert = {};
      }, 200);
      e.preventDefault();
      return;
    }

    // this.mseDataService.postFeedback(postData).then((res) => {
    this.alert = {
      msg_type: "success",
      text: "Thank you for valuable feedback. We will get back to you soon.",
    };
    setTimeout(() => {
      this.alert = {};
    }, 200);
    // });
  }
  navigateActionPerform(msg_type) {
    if (msg_type === "success") {
      // this.router.navigate(['/options'], { relativeTo: this.route });
      this.router.navigate([  "/home/steps/0"]);
    }
  }
  prev() {
    this.eventDataService.hanleFeedBackPreviousbtn(true);
    this.router.navigate([  "/home/steps/0"]);
  }

  setfeedbackForm(key, value) {
    let form = this.feedBackForm.value;
    form[key] = value;
    this.feedBackForm.get(key).setValue(value);
  }

  // FeedBack Form Data Dynamic Functions Used

  formValid(ev: FieldInfo) {
    this.validated = { ...this.validated, ...ev };
    let checkvalid = true;
    this.isValid = checkvalid;
    for (const key in this.validated) {
      if (this.validated[key] == "inValid" && checkvalid) {
        checkvalid = false;
        this.isValid = checkvalid;
        return;
      }
    }
    // this.cdRef.detectChanges();
  }

  errorInput(error: string) {
    let edata = error.split(":");
    if (edata.length > 0) {
      if (edata[0] == "add" && this.errorMessage.indexOf(edata[1]) == -1) {
        this.errorMessage.push(edata[1]);
      } else if (
        edata[0] == "rem" &&
        this.errorMessage.indexOf(edata[1]) != -1
      ) {
        this.errorMessage.splice(this.errorMessage.indexOf(edata[1]), 1);
      } else if (edata[0] == "rem" && edata[1] == "") {
        this.errorMessage.splice(this.errorMessage.indexOf(edata[1]), 1);
      }
    }
  }
  showErrorToast(){}

  changeinputinformfilled(op: Answer) {
    if (op.value) {
      this.answerMap.set(op.fieldNo, op);
      this.answerMap = new Map(this.answerMap);
      this.globalvar.feedBackFormAnswerMap = this.answerMap;
    }
  }

  removeinput(fieldid: number) {
    this.answerMap.delete(fieldid);
    this.answerMap = new Map(this.answerMap);
  }

  getConfigId(qus: Question) {
    if (qus?.configConditions.length) {
      const condiotionValue = this.codehelp.checkConfigCondition(
        qus?.configConditions,
        this.answerMap,
        ""
      );
      if (condiotionValue) {
        return condiotionValue;
      } else {
        return qus.configId;
      }
    } else {
      return qus.configId;
    }
  }

  getDisabled(qus: Question): boolean {
    const val = this.disableMap.get(qus.fieldNo);
    return val || false;
  }

  getValue(qus: Question) {
    const val = this.answerMap.get(qus.fieldNo);
    return val?.value || "";
    // return '';
  }

  getaltValue(qus: Question) {
    const val = this.answerMap.get(qus.fieldNo);
    return val?.altValue || "";
  }
}
